import React, { useState, useEffect, useRef } from 'react';
import BreadcrumbComponent from '../../../../components/common/Breadcrumb'
import NationalEmblem from '../../../../assets/svg_main/national_emblem.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Button from  '../../../../components/common/Button';
import BackArrowsvg from '../../../../assets/svg/BackArrowIconSvg.svg'
import CommonFormFields from '../../../Forms/CommonFormFields';
import { MigratedBenificryconstant, TemporaryBenificryconstant } from '@constants/index';
import endpoints from '@config/endpoints';
import { toast } from 'react-toastify';
import { getData, getDataWithCache, postDataJSON, putDataJSON } from '../../../../services/CommonApiService'
import { useSelector } from 'react-redux';
import WomanIcon from "../../../../assets/svg_main/Woman.svg";
import ManIcon from "../../../../assets/svg_main/Man.svg";
import { useDispatch } from 'react-redux';
import profilePic from '../../../../assets/png/default_profile.png'; 
import { RootState } from '@store/reducers';
import CustomTooltip from '@components/common/CustomTooltip';
import InfoBar from '@components/common/InfoBars';
import { updateForm } from '@store/actions/userManagementAction';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../../utils/base64Utils';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import BadgesComponent from '@components/common/Badges';
import { imageData, isBeneficiaryModified, isImageEdited, setAadhar, setBeneficiaryAbha, setBeneficiaryAuthType, setBeneficiaryData, setBeneficiaryGender, setBeneficiaryMobileNumber, setBeneficiaryRedgOption, setTsnID } from '@store/actions/beneficiaryAction';
import Auth from '@utils/auth';
import axios from '../../../../utils/axiosExt';
import { errorLogger } from '@utils/applicationLogUtils';
import Unauthorised from '@components/Auth/Unauthorised';
import './MigratedBenfTemp.css';
import AuthenticationOptionModal from '@pages/Beneficiary-block/CreateBeneficiary/AuthenticationOptionModal';
import BenefeciaryUnderMobNo from '@pages/Beneficiary-block/CreateBeneficiary/BenefeciaryUnderMobNo';
import BeneficiaryRedgeOptionModal from '@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryRedgeOptionModal';
import Demographic from '@pages/Beneficiary-block/CreateBeneficiary/Demographic';
import VerificationModal from '@pages/Beneficiary-block/CreateBeneficiary/VerificationModal';
import OTPVerification from '@pages/Beneficiary-block/CreateBeneficiary/OTP';
import FormatDate from '@utils/dateFormat';
import convertByteToImageURL from '@utils/convertByteToImageURL';
import CloseModal from '@components/common/CloseModal';
import BeneficiaryExistsModal from '@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryExistsModal';
import { benef_const } from '@constants/beneficiaryConstant';
interface HealthFComponentProps {
  page: string;
  flow: string;

}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  code?: any
}

export interface formStateType {
  [key: string]: objectType
}

interface CreateProps {
  breadcrumbItemName?: any;
}


const MigratedTemporaryBenificiary = (props: HealthFComponentProps,) => {
  const storedUserId = localStorage.getItem('userId');
  const userId = storedUserId
  const { id } = useParams();
  const { page, flow } = props;
  const initialBeneficiaryState = {
    caste: '',
    pgtvClassified: false,
    enrollSMS: false,
  };
  const Files = useSelector((state: RootState) => state.user.file);
  const navigate = useNavigate();
  const beneficiaryStore = useSelector((state: RootState) => state.beneficiary);
  const [ufId, setUfId] = useState<string>('');
  const [urbanRural, setUrbanRural] = useState<string>('');
  let isBenefHasFacilityData=false;
  let isBenefHasServiceData=false;
  const [temproryBenificiaryformdata, setTemproryBenificiaryFormData] = useState<any>(MigratedBenificryconstant);
  const [closeModal,setCloseModal]=useState<boolean>(false)
  const [consentLanguageData,setConsentLanguageData]=useState<any>([]);
  const [linkedBenefDetails, setLinkedBenefDetails] = useState<string>('');
  const [showExistsModal, setShowExistsModal] = useState(false);
  const [temproryBenificiaryFormState, setTemproryBenificiaryFormState] = useState<formStateType>({
    beneificery_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Gender: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    Beneficiary_DOB: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    abha_number: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Beneficiary_Mobile_Number: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    rch1_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    Spouse_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    caste: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    Religion: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    other_religion: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    Alternate_Phone_Number: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    state: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    Ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:""
    },
    Village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    sms: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    pvtg: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    Enroll_for_SMS: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  }
  )
   const [beneficiaryServiceProviderData, setBeneficiaryServiceProviderData] = useState<any>({
    Health_Provider_Name:{
      '#type': 'select',
      '#title': 'Health Provider Name',
      '#webform_key': 'Health_Provider_Name',
      '#required': true,
      '#isDisabled':true,
      '#options': [],

    },
    Asha_Name:{
      '#type': 'select',
      '#title': 'Asha /Mobiliser Name',
      '#webform_key': 'Asha_Name',
      '#required': false,
      '#isDisabled':true,
      '#options': [],
    }
    })
      const [beneficiaryFacilityDetailsData, setBeneficiaryFacilityDetailsData] = useState<any>({
           Facility_Type:{
            '#type': 'select',
            '#title': 'Facility Type',
            '#webform_key': 'Facility_type',
            '#required': true,
            '#isDisabled':false,
            '#options': [],
            },
          Facility_Name:{
            '#type': 'select',
            '#title': 'Facility Name',
            '#webform_key': 'Facility_Name',
            '#required': true,
            '#isDisabled':false,
            '#options':[],
          },
      })
   const [beneficiaryServiceProviderForm, setBeneficiaryServiceProviderFrom] = useState<any>({
    Asha_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    Health_Provider_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
  })
  const [beneficiaryFacilityDetailsForm, setBeneficiaryFacilityDetailsForm] = useState<any>({ 
    Facility_Name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
      Facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
      })
  const [beneficiary, setBeneficiary] = useState(initialBeneficiaryState);
  const [facilityDetails, setFacilityDetails] = useState<any>([]);
  const [genderId, setGenderId] = useState<string>('');
  const inputRef = useRef<any>(null);
  const [imageError, setImageError] = useState('');
  const [imageUrl, setImageUrl] = useState<string>('');
  const [BeneficiaryDate, setBeneficiaryDate] = useState<any>('');
  const [loginId, setLoginId] = useState<string>('');
  const [regId, setRegId] = useState<string>('');
  const [userType, setUserType] = useState<string>('')
  const [userName, setUserName] = useState<string>('')
  const [migratedBenfData, setMigratedBenfData] = useState<any>()
  const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
  const [facilityDetailsChanged, setFacilityDetailsChanged] = useState<boolean>(false);
  const dispatch = useDispatch()
  const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
    null,
  );
  const getBenfData = useSelector((state: RootState) => state.beneficiary.beneficiaryData);
  const getBeneficiaryData = useSelector((state: RootState) => state.beneficiary);
  const beneficiaryStoreData = useSelector((state: RootState) => state.beneficiary);
  const isImageModified = useSelector((state: RootState) => state.beneficiary.isImageEdited);
  const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
  const roleDetails=JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userRoleDetails')));
  const [showRedgOptionBeneficiary, setShowRedgOptionBeneficiary] = useState(false);
  const [showAuthBeneficiary, setShowAuthBeneficiary] = useState(false);
  const [showVerificationBeneficiary, setShowVerificationBeneficiary] = useState(false);
  const [showBenefeciaryUnderMobNoModal, setShowBenefeciaryUnderMobNoModal] = useState(false)
  const [showOTP, setShowOTP] = useState(false);
  const [showDemographicModal, setShowDemographicModal] = useState(false);
  const initialFetchMigratedBenf=async ()=>{
    try{
        const response = await getData<any>(`${endpoints.getBeneficiaryById}/${id}`);
        if(response.data?.length===0){
          setShowUnauthorized(true);
        }
        else{
          const migratedBenfDetails=response?.data[0];
          setMigratedBenfData(migratedBenfDetails);
          setTemproryBenificiaryFormState((prevState: any) => ({
              ...prevState,
              ['beneificery_name']: {
                ...prevState['beneificery_name'],
                value: migratedBenfDetails?.benf_name,

              },
              ['Gender']: {
                ...prevState['Gender'],
                value: migratedBenfDetails?.gender_name,
                id: migratedBenfDetails?.gender_id
              },
              ['Beneficiary_DOB']: {
                ...prevState['Beneficiary_DOB'],
                value: migratedBenfDetails?.dob,
              },
              ['Beneficiary_Mobile_Number']: {
                ...prevState['Beneficiary_Mobile_Number'],
                value: migratedBenfDetails?.mob,
              },
              ['Spouse_Name']: {
                ...prevState['Spouse_Name'],
                value: migratedBenfDetails?.spouse_name,
              },
              ['caste']: {
                ...prevState['caste'],
                value: migratedBenfDetails?.category_name,
                id:migratedBenfDetails?.category_id
              },
              ['Religion']: {
                ...prevState['Religion'],
                value: migratedBenfDetails?.religion_name,
                id: migratedBenfDetails?.religion_id
              },
              ['other_religion']: {
                ...prevState['other_religion'],
                value: migratedBenfDetails?.other_religion,
              },
              ['Alternate_Phone_Number']: {
                ...prevState['Alternate_Phone_Number'],
                value: migratedBenfDetails?.alternate_mob,
              },
              ['state']: {
                ...prevState['state'],
                value: `${migratedBenfDetails?.state_name}-${migratedBenfDetails?.state_code}`,
                id: migratedBenfDetails?.state_id,
                code:migratedBenfDetails?.state_code
              },
              ['district']: {
                ...prevState['district'],
                value: `${migratedBenfDetails?.dist_name}-${migratedBenfDetails?.dist_code}`,
                id: migratedBenfDetails?.dist_id,
                code:migratedBenfDetails?.dist_code
              },
              ['Ward']: {
                ...prevState['Ward'],
                value: migratedBenfDetails?.ward_name,
                id: migratedBenfDetails?.ward_id,
                code:migratedBenfDetails?.ward_code
              },
              ['Village']: {
                ...prevState['Village'],
                value: migratedBenfDetails?.village_name,
                id: migratedBenfDetails?.village_id,
                code:migratedBenfDetails?.village_code
              },
              ['rch1_id']: {
                ...prevState['rch1_id'],
                value: migratedBenfDetails?.rch_id,
              },
              ['abha_number']: {
                ...prevState['abha_number'],
                value: migratedBenfDetails?.abha_id,
              },
              ['pvtg']: {
                ...prevState['pvtg'],
                value: migratedBenfDetails?.is_pvtg_classified?"Yes":null,
              },
              ['sms']: {
                ...prevState['sms'],
                value: migratedBenfDetails?.enroll_for_sms,
              },     
            }))
            if(migratedBenfDetails?.healthprovider_id?.length>0?true:false){
            setBeneficiaryServiceProviderFrom((prevState: any) => ({
              ...prevState,
              ['Health_Provider_Name']: {
                ...prevState['Health_Provider_Name'],
                value: migratedBenfDetails?.health_provider_name?.length>0?migratedBenfDetails?.health_provider_name[0]:'',
                id: migratedBenfDetails?.healthprovider_id?.length>0?migratedBenfDetails?.healthprovider_id[0]:'',
              },
               ['Asha_Name']: {
                ...prevState['Asha_Name'],
                value: migratedBenfDetails?.mobiliser_f_name?.length>0?migratedBenfDetails?.mobiliser_f_name[0]:'',
                id: migratedBenfDetails?.mobiliser_id?.length>0?migratedBenfDetails?.mobiliser_id[0]:'',
              },           
             }))
            }
            if(migratedBenfDetails?.facility_id?.length>0?true:false){
            setBeneficiaryFacilityDetailsForm((prevState: any) => ({
              ...prevState,
                ['Facility_type']: {
                ...prevState['Facility_type'],
                value: migratedBenfDetails?.facility_type?.length>0?migratedBenfDetails?.facility_type[0]:'',
                id: migratedBenfDetails?.facility_type_id?.length>0?migratedBenfDetails?.facility_type_id[0]:'',           
              },
              ['Facility_Name']: {
                ...prevState['Facility_Name'],
                value: migratedBenfDetails?.facility_name?.length>0?migratedBenfDetails?.facility_name[0]:'',
                id: migratedBenfDetails?.facility_id?.length>0?migratedBenfDetails?.facility_id[0]:'',
              },
             }))
            }
            isBenefHasServiceData=migratedBenfDetails?.healthprovider_id?.length>0 ? true : false;
            isBenefHasFacilityData=migratedBenfDetails?.facility_id?.length>0 ? true : false;
            if(!isBenefHasServiceData && !isBenefHasFacilityData){
              await fecilityServiceData();
            }
            else{
              setBeneficiaryFacilityDetailsData((prevState: any) => {
                return {
                  ...prevState,
                  ['Facility_Name']: {
                    ...prevState['Facility_Name'],
                    '#isDisabled': true
                  },
                  ['Facility_Type']: {
                    ...prevState['Facility_Type'],
                    '#isDisabled': true,
                  }
                }
              })
            }
            if(migratedBenfDetails?.is_pvtg_classified){
              setTemproryBenificiaryFormData((prevState: any) => {
                return {
                  ...prevState,
                  pvtg: {
                    '#type': 'radioButton',
                    '#title': 'Is PVTG Classified',
                    '#webform_key': 'pvtg',
                    '#required': true,
                    '#isDisabled': false,
                    '#group': 'beneficiaryCreate',
                    '#options': ["Yes", "No"]
                  }
                }
              })
            }
        }
        const imageRes= await getData<any>(`${endpoints.getImageByBeneficiaryID(id)}`)
            if (imageRes?.data[0]) {
                const imageurl = convertByteToImageURL(imageRes.data[0]?.image?.data);
                setImageUrl(imageurl);
            }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error);
    }
  }
  const fecilityServiceData=async ()=>{
     const facility_details_response = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      setFacilityDetails(facility_details_response.data[0]);
      const parentFacility = facility_details_response.data[0].find((item: any) => item.is_parent === true);
      let facilityIdToGetProvider=parentFacility?.facility_id
      setBeneficiaryFacilityDetailsForm((prevState: any) => ({
        ...prevState,
        ['Facility_Name']: {
          ...prevState['Facility_Name'],
          value: parentFacility?.facility_name,
          id: parentFacility?.facility_id
        },
        ['Facility_type']: {
          ...prevState['Facility_type'],
          value: parentFacility?.facility_type_name,
          id: parentFacility?.facility_type_id
        }

      }))
      setBeneficiaryFacilityDetailsData((beneficiary_facilitydetails: { Health_Provider_Name: any, Facility_Name: any, Asha_Name: any, Ward: any, Village: any }) => ({
        ...beneficiary_facilitydetails,
        Facility_Name: {
          ...beneficiary_facilitydetails.Facility_Name,
          '#options': facility_details_response.data[0]?.map((key: any) => ({
            value: key.facility_name,
            label: key.facility_name,
            id: key.facility_id
          })),
          '#isDisabled': facility_details_response.data[0]?.length=== 1 ? true : false
        }
      }));

      if (facility_details_response.data[0].length === 1) {
        facilityIdToGetProvider=facility_details_response.data[0][0].facility_id;
       
        setBeneficiaryFacilityDetailsForm((prevState: any) => ({
          ...prevState,
          ['Facility_Name']: {
            ...prevState['Facility_Name'],
            value: facility_details_response.data[0][0].facility_name,
            id: facility_details_response.data[0][0].facility_id
          },
          ['Facility_type']: {
            ...prevState['Facility_type'],
            value: facility_details_response.data[0][0].facility_type_name,
            id: facility_details_response.data[0][0].facility_type_id
          }
        }))
      }
      facilityIdToGetProvider?.trim() && fetchHealthProviderData(facilityIdToGetProvider);
      if(userDetail.usertype_name === 'Field Level User'){
        setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { Asha_Name: any }) => ({
            ...beneficiary_facilitydetails,
            ['Asha_Name']: {
                ...beneficiary_facilitydetails['Asha_Name'],
                '#isDisabled': true,
            }
        }));
    }
    else{
      setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { Asha_Name: any }) => ({
            ...beneficiary_facilitydetails,
            ['Asha_Name']: {
                ...beneficiary_facilitydetails['Asha_Name'],
                '#isDisabled': false,
            }
        }));
    }
    if(roleDetails?.includes('Administrator')){
     setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { Health_Provider_Name: any }) => ({
            ...beneficiary_facilitydetails,
            ['Health_Provider_Name']: {
                ...beneficiary_facilitydetails['Health_Provider_Name'],
                '#isDisabled': false,
            }
        }));
    }
    else{
       setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { Health_Provider_Name: any }) => ({
            ...beneficiary_facilitydetails,
            ['Health_Provider_Name']: {
                ...beneficiary_facilitydetails['Health_Provider_Name'],
                '#isDisabled': true,
            }
        }));
    }
      const facilityTypes = facility_details_response?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id
      }));
      const filteredFacilityType = facilityTypes.filter((obj: any, index: any) => {
        return index === facilityTypes.findIndex((o: any) => obj.value === o.value);
      })
      setBeneficiaryFacilityDetailsData((prevState: any) => {
        return {
          ...prevState,
          ['Facility_Type']: {
            ...prevState['Facility_Type'],
            '#options': filteredFacilityType,
            '#isDisabled': facilityTypes?.length=== 1 ? true : false
          }
        }
      })
  }
  useEffect( () => {
    setTemproryBenificiaryFormData((prevState: any) => {
      return {
        ...prevState,
        ['Gender']: {
          ...prevState['Gender'],
          '#isDisabled': true,
        }
      }
    })
    const fetchData = async () => {
      await initialFetchMigratedBenf();
      setUrbanRural(userDetail.urban_rural_name);
      setUserType(userDetail.usertype_name);
      setUserName(userDetail.first_name + ' ' + userDetail.middle_name + ' ' + userDetail.last_name);
      if (userDetail.urban_rural_name === 'urban') {
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Ward']: {
              ...prevState['Ward'],
              '#options': [],
              '#isDisabled': false,
            },
            ['Village']: {
              ...prevState['Village'],
              '#isDisabled': true,
            }
          }
        })
      }
      else {
        setTemproryBenificiaryFormData((prevState: any) => {
          return {
            ...prevState,
            ['Ward']: {
              ...prevState['Ward'],
              '#isDisabled': true,
            },
            ['Village']: {
              ...prevState['Village'],
              '#options': [],
              '#isDisabled': false,
            }
          }
        })
      }
      const staticBenfCreateDetails = await getDataWithCache<any>(`${endpoints.getStaticBenfCreateDetails}`);
      const caste = staticBenfCreateDetails?.data.categoryData.map((key: any) => ({
        value: key.category_name,
        label: key.category_name,
        id: key.category_id,
        code: key.category_code
      }));
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,

          ['caste']: {
            ...prevState['caste'],
            '#options': caste
          }
        }
      })

      const religion = staticBenfCreateDetails?.data.religionData[0].map((key: any) => ({
        value: key.religion_name,
        label: key.religion_name,
        id: key.religion_id,
        code: key.religion_code
      }));
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Religion']: {
            ...prevState['Religion'],
            '#options': religion
          }
        }
      })

     
      if (beneficiaryStore.beneficiaryGender === "Female" || beneficiaryStore.beneficiaryGender === "F") {
        setGenderId(staticBenfCreateDetails.data.genderData?.find((g: any) => g.gender_code === '1002')?.gender_id)
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          Gender: {
            ...prevState.Gender,
            value: 'Female',
          },
        }));
      }
      else if (beneficiaryStore.beneficiaryGender === "Male" || beneficiaryStore.beneficiaryGender === "M") {
        setGenderId(staticBenfCreateDetails.data.genderData?.find((g: any) => g.gender_code === '1001')?.gender_id)
        setTemproryBenificiaryFormState((prevState: any) => ({
          ...prevState,
          Gender: {
            ...prevState.Gender,
            value: 'Male',
          },
        }));
      }
      setLoginId(staticBenfCreateDetails.data.loginProcessData[3].login_process_id)
      setRegId(staticBenfCreateDetails.data.registrationProcessData[2].reg_process_id)
    }
    fetchData();
  }, [])
  useEffect(() => {

    if (temproryBenificiaryFormState.caste.value !== 'ST') {
      delete temproryBenificiaryformdata.pvtg;
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['pvtg']: {
          ...prevState['pvtg'],
          value: null,
          isError: false,
          message: ''
        },
      }))
    }
    else {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          pvtg: {
            '#type': 'radioButton',
            '#title': 'Is PVTG Classified',
            '#webform_key': 'pvtg',
            '#required': true,
            '#isDisabled': false,
            '#group': 'beneficiaryCreate',
            '#options': ["Yes", "No"]
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['pvtg']: {
          ...prevState['pvtg'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
  }, [temproryBenificiaryFormState.caste.value])
  useEffect(() => {
    if (temproryBenificiaryFormState.Religion.value !== 'Others') {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['other_religion']: {
            ...prevState['other_religion'],
            '#isDisabled': true,
            '#required': false,
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['other_religion']: {
          ...prevState['other_religion'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
    else {
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['other_religion']: {
            ...prevState['other_religion'],
            '#isDisabled': false,
            '#required': true,
          }
        }
      })
      setTemproryBenificiaryFormState((prevState: any) => ({
        ...prevState,
        ['other_religion']: {
          ...prevState['other_religion'],
          value: '',
          isError: false,
          message: ''
        },
      }))
    }
  }, [temproryBenificiaryFormState.Religion.value])

  const fetchHealthProviderData = async (facilityId:any) => {
    try{
   const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(facilityId)}`);
    const HealthProvider = Health_provider?.data?.map((key: any) => ({
      value: `${key.f_name} ${key.l_name}`,
      label: `${key.f_name} ${key.l_name}`,
      id: key.user_id,
      code: key.user_code,
      ufTaggedId: key.uf_tagged_id
    }));
    setBeneficiaryServiceProviderData((prevState: any) => {
      return {
        ...prevState,
        ['Health_Provider_Name']: {
          ...prevState['Health_Provider_Name'],
          '#options': HealthProvider
        }
      }
    })

    if (userDetail?.usertype_name === 'Facility Level User' || Health_provider?.data.length === 1) {
      const loggedInUserName=userDetail.first_name + ' ' + userDetail.middle_name + ' ' + userDetail.last_name;
      const healthProviderData = Health_provider?.data.find((item: any) => `${item.f_name} ${item.l_name}` === loggedInUserName.replace('null', '').replace('  ', ' '));
      if (healthProviderData) {
        setBeneficiaryServiceProviderFrom((prevState: any) => ({
          ...prevState,
          ['Health_Provider_Name']: {
            ...prevState['Health_Provider_Name'],
            value: healthProviderData?.f_name + ' ' + healthProviderData?.l_name,
            id: healthProviderData?.user_id
          }
        }))
        const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`);
        const Ashaname = AshaName?.data.map((key: any) => ({
          value: key.f_name + " " + key.l_name,
          label: key.f_name + " " + key.l_name,
          id: key.mobiliser_id,
          code: key.user_code
        }));
        setBeneficiaryServiceProviderData((prevState: any) => {
          return {
            ...prevState,
            ['Asha_Name']: {
              ...prevState['Asha_Name'],
              '#options': Ashaname
            }
          }
        })
      }
    }
  }
  catch(error:any){
    errorLogger(error?.response?.data?.data||error?.response?.data||error?.response||error);
  }
}
  const handleUploadClick = (method: 'local' | 'url') => {
    inputRef.current?.click();
    setUploadMethod(method);
  };
  const isValueContainsOnlyDigits = (value: any) => {
    return /^\d*$/.test(value);
  };
  const handleFormChange = (value: any, key: string, id: any, option: any, code: any,) => {

    if (value && key === 'Beneficiary_DOB') {
      const date = new Date(value)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formatedDate = `${year}-${month}-${day}`
      setBeneficiaryDate(formatedDate)

    }
    if ((key === "Beneficiary_Mobile_Number" || key === 'Alternate_Phone_Number') && (!isValueContainsOnlyDigits(value) || value.length > 10)) {
      return
    }
    setTemproryBenificiaryFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  }
   const handleServiceDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        if (value && key === 'Health_Provider_Name') {

     setBeneficiaryServiceProviderFrom((prevState: any) => ({
        ...prevState,
        Asha_Name: {
          ...prevState.Asha_Name,
          value: '',
          id: '',
          isError: false,
          message: '',
        }
      }));
      const ufTaggedId = option.find((item: any) => item.id === id);
      setUfId(ufTaggedId.ufTaggedId)
    }
        setBeneficiaryServiceProviderFrom((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }
    const handleFacilityDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
      setFacilityDetailsChanged(true);
          setBeneficiaryFacilityDetailsForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }
  const fetchAshaData = async () => {

    const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
    const Ashaname = AshaName?.data.map((key: any) => ({
      value: key.f_name + " " + key.l_name,
      label: key.f_name + " " + key.l_name,
      id: key.mobiliser_id,
      code: key.user_code
    }));
    setBeneficiaryServiceProviderData((prevState: any) => {
      return {
        ...prevState,
        ['Asha_Name']: {
          ...prevState['Asha_Name'],
          '#options': Ashaname
        }
      }
    })
  }
  const fetchWardVillageData = async () => {
    const ufIdData = facilityDetails?.find((item: any) => item.facility_name === beneficiaryFacilityDetailsForm.Facility_Name.value);
    if (urbanRural === 'urban') {
      const wardData =ufIdData?.uf_id && await getDataWithCache<any>(`${endpoints.getWardByUfId(ufIdData?.uf_id)}`);
      const ward_options = wardData?.data[0]?.map((key: any) => ({
        value: key.ward_name + "-" + key.ward_code,
        label: key.ward_name + "-" + key.ward_code,
        id: key.ward_id
      }))
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Ward']: {
            ...prevState['Ward'],
            '#options': ward_options
          },
          ['Village']: {
            ...prevState['Village'],
            '#isDisabled': true,
          }
        }
      })
    }
    else {
      const villageData =ufIdData?.uf_id && await getDataWithCache<any>(`${endpoints.getVillageByUfId(ufIdData.uf_id)}`);
      const village_options = villageData?.data[0].map((key: any) => ({
        value: key.village_name + "-" + key.village_code,
        label: key.village_name + "-" + key.village_code,
        id: key.village_id
      }))
      setTemproryBenificiaryFormData((prevState: any) => {
        return {
          ...prevState,
          ['Village']: {
            ...prevState['Village'],
            '#options': village_options
          },
          ['Ward']: {
            ...prevState['Ward'],
            '#isDisabled': true
          }
        }
      })
    }
  }
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (fileSize > 1048576) {
        setImageError('File size must be less than or equal to 1MB');
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setImageUrl(URL.createObjectURL(selectedFile));
      setUploadMethod(null);
      const file = selectedFile;
      const formData = new FormData()
      formData.append('file', selectedFile);
      dispatch(updateForm("file", formData));

    }
  };

  useEffect(() => {
    if (facilityDetailsChanged && beneficiaryFacilityDetailsForm.Facility_Name.value !== '' && beneficiaryFacilityDetailsForm.Facility_Name.value !== undefined && beneficiaryFacilityDetailsForm.Facility_Name.value) {
       fetchHealthProviderData(beneficiaryFacilityDetailsForm.Facility_Name.id);
      fetchWardVillageData();
    }
  }, [beneficiaryFacilityDetailsForm.Facility_Name.value])
  useEffect(() => {
    if (!isBenefHasFacilityData && !isBenefHasServiceData && beneficiaryServiceProviderForm.Health_Provider_Name.value !== '' && beneficiaryServiceProviderForm.Health_Provider_Name.value !== undefined &&
      ufId !== '' && ufId !== undefined
    ) {
      fetchAshaData();
    }
  }, [ufId])
  useEffect(() => {
           if (isImageModified) {
              dispatch(isBeneficiaryModified(true))
          }
          else {
              dispatch(isBeneficiaryModified(false))
          }
  }, [ isImageModified])
  const abhaNumberSetting=(abhaNumber:string)=>{
    if(abhaNumber?.length>0)
     toast.success("Beneficiary has been verified successfully", {
               position: "top-center"
      })
      else
      toast.error("Something went wrong", {
        position: "top-center"
      })
    setTemproryBenificiaryFormState((prevState: any) => ({
      ...prevState,
      abha_number: {
        ...prevState.abha_number,
        value: abhaNumber,
      },
    }));
    setConsentLanguageData(getBeneficiaryData?.consentLanguageID);
    dispatch(setBeneficiaryGender(''));
    dispatch(setBeneficiaryRedgOption(''));
    dispatch(setBeneficiaryAuthType(''));
    dispatch(setBeneficiaryData([]));
    dispatch(setBeneficiaryAbha(''));
    dispatch(setTsnID(''));
    dispatch(setBeneficiaryMobileNumber(''))
    dispatch(setAadhar(''))
  }
   const closeBeneficiarRedgOptionModal = (option: string) => {
          setShowRedgOptionBeneficiary(false);
          if (option === 'ABHA' || option === 'Aadhaar') {
            setShowAuthBeneficiary(true);
          }
          if (option === 'Phone_Number') {
            setShowVerificationBeneficiary(true);
          }
          if (option === 'back') {
            setShowRedgOptionBeneficiary(false);
  
          }
        };
      
        const closeBeneficiarAuthModal = (authType: string) => {
          setShowAuthBeneficiary(false);
          if (authType === 'back') {
            setShowRedgOptionBeneficiary(true);
          }
          else if (authType !== '') {
            setShowVerificationBeneficiary(true);
          }
        };

          const closeBeneficiaryExistModal =async (type:string, abhaNumber?:string) =>{
              setShowExistsModal(false);
              if(type === benef_const.verifyOptions.yes){
                if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber){
                  setShowOTP(true);
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp){
                  setShowOTP(true);
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.demographics){
                  if (abhaNumber) {
                    await abhaNumberSetting(abhaNumber.replace(/-/g, ""));
                  }
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha){
                  if (abhaNumber) {
                    await abhaNumberSetting(abhaNumber.replace(/-/g, ""));
                  }
                }
              }else if (type === benef_const.verifyOptions.back) {
                if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber){
                  setShowVerificationBeneficiary(true);
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp)
                {
                  setShowVerificationBeneficiary(true)  
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.demographics)
                {
                  setShowVerificationBeneficiary(true);
                }
                else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha){
                  setShowRedgOptionBeneficiary(true);
                  setTimeout(() => {
                    dispatch(setBeneficiaryRedgOption(''));
                    dispatch(setBeneficiaryAuthType(''));
                  }, 1000);
                }
              }
              else if(type === benef_const.verifyOptions.backToOtherMethod){
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                  dispatch(setBeneficiaryRedgOption(''));
                  dispatch(setBeneficiaryAuthType(''));
                }, 1000);
              }
              else {
                setShowDemographicModal(false);
                setTimeout(() => {
                  dispatch(setBeneficiaryGender(''));
                  dispatch(setBeneficiaryRedgOption(''));
                  dispatch(setBeneficiaryAuthType(''));
                }, 1000);
              }
            }
      
        const closeVerificationBeneficiary = (type: string) => {
          setShowVerificationBeneficiary(false);
          if ((type === 'submit' && beneficiaryStoreData.beneficiaryAuthType === 'OTP') ||
            (type === 'submit' && beneficiaryStoreData.beneficiaryRedgeOption === 'Phone_Number')) {
            setShowOTP(true);
          }
          else if ((type === 'submit' && beneficiaryStoreData.beneficiaryAuthType === 'OTP') ||
            (type === 'submit' && beneficiaryStoreData.beneficiaryRedgeOption === 'ABHA')) {
            setShowOTP(true);
          }
          else if (type === 'submit' && beneficiaryStoreData.beneficiaryAuthType === 'Demographics') {
            setShowDemographicModal(true);
          }
          else if (type === 'back') {
            if (beneficiaryStoreData.beneficiaryRedgeOption === 'Phone_Number') {
              setShowRedgOptionBeneficiary(true);
            }
            else if ((beneficiaryStoreData.beneficiaryRedgeOption === 'Aadhaar' || beneficiaryStoreData.beneficiaryRedgeOption === 'ABHA') &&
            beneficiaryStoreData.beneficiaryAuthType !== '') {
              setShowAuthBeneficiary(true);
            }
            else if (beneficiaryStoreData.beneficiaryRedgeOption === 'Aadhaar' || beneficiaryStoreData.beneficiaryRedgeOption === 'ABHA') {
              setShowAuthBeneficiary(true);
            }
          }
          else if( type === benef_const.verifyOptions.showExistModal){
            setShowExistsModal(true);
          }
          else {
            setTimeout(() => {
              dispatch(setBeneficiaryGender(''));
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
          }
        }
        const closeDemographicModal = (type: string,abhaNumber:string) => {
          if (type === "submit") {
            setShowDemographicModal(false);
            abhaNumberSetting(abhaNumber.replace("-", "").replace("-", ""))
          }
          else if (type === 'back') {
            setShowDemographicModal(false);
            setShowVerificationBeneficiary(true);
          }
          else if(type==="backToOtherMethod"){
            setShowDemographicModal(false);
            setShowRedgOptionBeneficiary(true);
            setTimeout(() => {
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
          }
          else if( type === benef_const.verifyOptions.showExistModal){
            setShowExistsModal(true);
          }
          else {
            setShowDemographicModal(false);
            setTimeout(() => {
              dispatch(setBeneficiaryGender(''));
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
          }
        }
        const closeOTPModal = (type: string,abhaNumber:string) => {
          setShowOTP(false);
          if (type === 'close') {
            setTimeout(() => {
              dispatch(setBeneficiaryGender(''));
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
          }
          else if (type === 'back') {
            setShowVerificationBeneficiary(true);
          }
          else if (type === "submit" && beneficiaryStoreData.beneficiaryRedgeOption === 'Phone_Number') {
            setShowBenefeciaryUnderMobNoModal(true);
          }
          else if (type === "submit" && beneficiaryStoreData.beneficiaryRedgeOption === 'Aadhaar') {
            abhaNumberSetting(abhaNumber.replace("-", "").replace("-", ""))
          }
          else if (type === "submit" && beneficiaryStoreData.beneficiaryRedgeOption === 'ABHA') {
            abhaNumberSetting(abhaNumber.replace("-", "").replace("-", ""))
          }
          else if( type === benef_const.verifyOptions.showExistModal){
            setShowExistsModal(true);
          }
          else if(type==="backToOtherMethod"){
            setShowRedgOptionBeneficiary(true);
            setTimeout(() => {
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
          }
        }
        const closeBenefeciaryUnderMobNoModal = (type: string) => {
          if (type === 'back') {
            setShowBenefeciaryUnderMobNoModal(false);
            setShowVerificationBeneficiary(true);
          }
          else if (type === 'submit') {
            setShowBenefeciaryUnderMobNoModal(false);
            abhaNumberSetting(getBenfData[0].abhaId.replace("-", "").replace("-", ""))
          }
          else {
            setTimeout(() => {
              dispatch(setBeneficiaryGender(''));
              dispatch(setBeneficiaryRedgOption(''));
              dispatch(setBeneficiaryAuthType(''));
            }, 1000);
            setShowBenefeciaryUnderMobNoModal(false);
          }
        }
  const handleSubmit = async () => {
    const isError: boolean[] = [];
    const beneficiaryFormStateError = {
      ...temproryBenificiaryFormState
    };
    let isBeneficiaryFormError = false;
    Object.keys(beneficiaryFormStateError).map((item) => {

      if (item === 'beneificery_name') {
        if (!beneficiaryFormStateError.beneificery_name?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Beneficiary name cannot be kept blank. Enter a valid beneficiary name.';
        }
        else if (!/^[a-zA-Z\s]+$/.test(beneficiaryFormStateError.beneificery_name?.value)) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Entered beneficiary name is invalid. Number & Special characters are not allowed.';
        } else if (beneficiaryFormStateError.beneificery_name?.value.length > 100) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.beneificery_name.isError = true;
          beneficiaryFormStateError.beneificery_name.message = 'Entered beneficiary name length is invalid. Max 100 characters are allowed.';
        }
        else {
          beneficiaryFormStateError.beneificery_name.isError = false;
        }
      }

      if (item === 'Beneficiary_DOB') {
        if (!beneficiaryFormStateError.Beneficiary_DOB?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Beneficiary_DOB.isError = true;
          beneficiaryFormStateError.Beneficiary_DOB.message = 'Select Beneficiary DOB.';
        } else {
          beneficiaryFormStateError.Beneficiary_DOB.isError = false;
        }
      }
      if (item === 'Alternate_Phone_Number') {
        if (beneficiaryFormStateError.Alternate_Phone_Number?.value?.length !== 0 && temproryBenificiaryformdata.Alternate_Phone_Number['#required']) {
          if (!/^\d+$/.test(beneficiaryFormStateError.Alternate_Phone_Number.value)) {
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.isError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.message = "Phone number contains invalid characters. Enter a valid phone number.";
          }else if(beneficiaryFormStateError?.Alternate_Phone_Number?.value?.length !== 10){
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.isError = true;
            beneficiaryFormStateError.Alternate_Phone_Number.message = "Mobile number must contain 10 digits. Enter a valid mobile number.";
          }
        }
        else {
          beneficiaryFormStateError.Alternate_Phone_Number.isError = false;
        }
      }
      if (item === 'Beneficiary_Mobile_Number') {
        if (beneficiaryFormStateError.Beneficiary_Mobile_Number.value?.length !== 0 && temproryBenificiaryformdata.Beneficiary_Mobile_Number['#required']) {
          if (!/^\d+$/.test(beneficiaryFormStateError.Beneficiary_Mobile_Number.value)) {
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.message = "Phone number contains invalid characters. Enter a valid phone number.";
          }else if(beneficiaryFormStateError?.Beneficiary_Mobile_Number?.value?.length !== 10){
            isBeneficiaryFormError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = true;
            beneficiaryFormStateError.Beneficiary_Mobile_Number.message = "Mobile number must contain 10 digits. Enter a valid mobile number.";
          }
        }
        else {
          beneficiaryFormStateError.Beneficiary_Mobile_Number.isError = false;
        }
      }
      if (item === 'pvtg' && temproryBenificiaryformdata?.pvtg) {
        if (!beneficiaryFormStateError.pvtg.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.pvtg.isError = true;
          beneficiaryFormStateError.pvtg.message = 'Is PVTG Classified cannot be empty. Choose either Yes or No.';
        }
        else {
          beneficiaryFormStateError.pvtg.isError = false;
        }
      }
      if (item === 'Spouse_Name') {
        if (!beneficiaryFormStateError.Spouse_Name?.value || beneficiaryFormStateError.Spouse_Name.value === 'Select') {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Spouse name cannot be kept blank. Enter a valid spouse name.';
        }
        else if (!/^[a-zA-Z\s]+$/.test(beneficiaryFormStateError.Spouse_Name?.value)) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Entered spouse name is invalid. Number & Special characters are not allowed.';
        }
        else if (beneficiaryFormStateError.Spouse_Name?.value.length > 100) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.Spouse_Name.isError = true;
          beneficiaryFormStateError.Spouse_Name.message = 'Entered spouse name length is invalid. Max 100 characters are allowed.';
        } else {
          beneficiaryFormStateError.Spouse_Name.isError = false;
        }
      }
      if (item === 'other_religion' && temproryBenificiaryformdata.other_religion["#isDisabled"] === false) {
        if (temproryBenificiaryFormState.Religion.value !== 'Others') {
          beneficiaryFormStateError.other_religion.isError = false;
        }
        if (!beneficiaryFormStateError.other_religion?.value) {
          isBeneficiaryFormError = true;
          beneficiaryFormStateError.other_religion.isError = true;
          beneficiaryFormStateError.other_religion.message = 'Enter the details other religion';
        }
        else {
          beneficiaryFormStateError.other_religion.isError = false;
        }
      }
      setTemproryBenificiaryFormState(beneficiaryFormStateError);
      isError[0] = isBeneficiaryFormError;
    })
    const beneficiaryServiceProviderFormError = {
      ...beneficiaryServiceProviderForm
    };
    let isBeneficiaryServiceProviderFormError = false;
    Object.keys(beneficiaryServiceProviderFormError).map((item) => {
      if (item === 'Health_Provider_Name') {
        if ((!beneficiaryServiceProviderFormError.Health_Provider_Name?.value || beneficiaryServiceProviderFormError.Health_Provider_Name.value === 'Select') && beneficiaryServiceProviderData.Health_Provider_Name['#required']) {
          isBeneficiaryServiceProviderFormError = true;
          beneficiaryServiceProviderFormError.Health_Provider_Name.isError = true;
          beneficiaryServiceProviderFormError.Health_Provider_Name.message = 'Select a valid Health Provider Name from the dropdown';
        } else {
          beneficiaryServiceProviderFormError.Health_Provider_Name.isError = false;
        }
      }
      setBeneficiaryServiceProviderFrom(beneficiaryServiceProviderFormError);
      isError[1] = isBeneficiaryServiceProviderFormError;
    })
    const beneficiaryFacilityFormError = {
      ...beneficiaryFacilityDetailsForm
    };
    let isBeneficiaryFacilityFormError = false;
    Object.keys(beneficiaryFacilityFormError).map((item) => {
      if (item === 'Facility_Name') {
        if (!beneficiaryFacilityFormError.Facility_Name?.value) {
          isBeneficiaryFacilityFormError = true;
          beneficiaryFacilityFormError.Facility_Name.isError = true;
          beneficiaryFacilityFormError.Facility_Name.message = 'Select a valid facility name from the dropdown';
        } else {
          beneficiaryFacilityFormError.Facility_Name.isError = false;
        }
      }
      if (item === 'Facility_type') {
        if ((!beneficiaryFacilityFormError.Facility_type?.value || beneficiaryFacilityFormError.Facility_type.value === 'Select') && beneficiaryFacilityDetailsData.Facility_Type['#required']) {
          isBeneficiaryFacilityFormError = true;
          beneficiaryFacilityFormError.Facility_type.isError = true;
          beneficiaryFacilityFormError.Facility_type.message = 'Select a valid facility type from the dropdown';
        } else {
          beneficiaryFacilityFormError.Facility_type.isError = false;
        }
      }
      setBeneficiaryFacilityDetailsForm(beneficiaryFacilityFormError);
      isError[2] = isBeneficiaryFacilityFormError;
    })
    
    if (!isBeneficiaryFormError && !isBeneficiaryServiceProviderFormError && !isBeneficiaryFacilityFormError) {
        const payload = {
          benefId: migratedBenfData.benef_id,
          genderId: temproryBenificiaryFormState?.Gender.id,
          abhaId: temproryBenificiaryFormState?.abha_number.value,
          beneficiaryName: temproryBenificiaryFormState?.beneificery_name?.value,
          beneficiaryDob: FormatDate(migratedBenfData?.dob),
          primaryMob: temproryBenificiaryFormState?.Beneficiary_Mobile_Number?.value,
          abhaAddress: migratedBenfData?.abha_address,
          spouseName: temproryBenificiaryFormState?.Spouse_Name?.value,
          religionId: temproryBenificiaryFormState?.Religion?.id || null,
          otherReligion: temproryBenificiaryFormState?.other_religion?.value || null,
          categoryId: temproryBenificiaryFormState?.caste?.id ? temproryBenificiaryFormState?.caste?.id : null,
          alternateMob: temproryBenificiaryFormState?.Alternate_Phone_Number?.value,
          healthProviderId: beneficiaryServiceProviderForm?.Health_Provider_Name?.id ? [beneficiaryServiceProviderForm?.Health_Provider_Name?.id] : [],
          mobiliserId: beneficiaryServiceProviderForm?.Asha_Name?.id ? [beneficiaryServiceProviderForm?.Asha_Name?.id] : [],
          is_mobiliser_changed: ((migratedBenfData?.mobiliser_id?.length>0 ? migratedBenfData?.mobiliser_id[0] : '')=== (beneficiaryServiceProviderForm.Asha_Name?.id?beneficiaryServiceProviderForm.Asha_Name?.id:''))?false:true,
          is_healthprovider_changed: ((migratedBenfData?.healthprovider_id?.length>0 ? migratedBenfData?.healthprovider_id[0] : '') === (beneficiaryServiceProviderForm.Health_Provider_Name?.id? beneficiaryServiceProviderForm.Health_Provider_Name?.id:''))?false:true ,
          isPvtgClassified: temproryBenificiaryFormState.caste.value !== 'ST' ? null : temproryBenificiaryFormState.pvtg.value === 'Yes' ? true : false,
          enrollForSms: temproryBenificiaryFormState?.sms.value,
          effectiveFromDt: null,
          wardId: temproryBenificiaryFormState?.Ward?.id || null,
          villageId: temproryBenificiaryFormState?.Village?.id || null,
          facilityId: beneficiaryFacilityDetailsForm.Facility_Name.id,
          isBenfMigrated:migratedBenfData?.is_migrated,
          isVerifiedInRCH2:(migratedBenfData?.abha_id ?? '') !== (temproryBenificiaryFormState?.abha_number.value ?? ''),
          abhaVerified:(migratedBenfData?.abha_id ?? '')!==(temproryBenificiaryFormState?.abha_number.value ?? ''),
          parentUserId: userId,
          parentUserTypeId: null,
          parentRoleId: null, 
          consentTemplateDetails:consentLanguageData? consentLanguageData.map((item:any)=>({consent_template_id:item.consent_template_id})): null
        }
        try {
          const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload))
          const response = await putDataJSON<any>(`${endpoints.updateBeneficiary}`, {data:encodedPayload});
            try {
              if (Files) {
                if(Files instanceof FormData) {
                  Files.append("imageType", "beneficiary_profile");
                  Files.append("objectId", migratedBenfData?.benef_id);
                 }
                const responses = await axios.post(`${endpoints.beneficiaryImageUpload}`,Files, Auth.loggedInWithMultipart())
              }
            }        catch(error:any){
                errorLogger(error?.response?.data||error?.response||error)
              }
          
        dispatch(updateForm("file", null));
        dispatch(isImageEdited(false));
        dispatch(isBeneficiaryModified(false));
        dispatch(imageData(''));
        navigate("/beneficiaries");
        toast.success("Beneficiary updated successfully", {
            position: "top-center"
        })
         
        }
        catch(error:any){
          toast.error("Something went wrong", {
                position: "top-center"
              })
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
  }
    
  
  const handleVerifyButton=()=>{
    dispatch(setBeneficiaryGender(migratedBenfData?.gender_name));
    setShowRedgOptionBeneficiary(true);

  }
 const closeCreateModal=(value:boolean)=>{
    if(value){
      setCloseModal(false);
      navigate("/beneficiaries");
    }
    else{
      setCloseModal(false);
    }
  }
  return (
    <>
    {showUnauthorized?<Unauthorised/>:
    <div className="temp_benf_wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: 'Service Provider', label: 'Service Provider' },
              { value: 'Migrated Beneficiary Registration', label: 'Migrated Beneficiary Registration' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <CommonHamburgar>
              <LeftNavBar
                navItems={['Beneficiary Details']}
                currentTab={'Beneficiary Details'}
                handleNavClick={() => { }}
              />
            </CommonHamburgar>
            <Link to={'/beneficiaries'}>
              <Button
                onClick={() => { }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
            {
              imageUrl ? <div
                className="profile-picture"
                style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }}
              ></div> : <img
                className="profile-picture"
                src={profilePic}
                alt='Profile Image'
              />
            }
            <div style={{ display: "flex", flexDirection: "column", fontSize: "13px" }}>
              <div className="name">{migratedBenfData?.benf_name}</div>
              <div style={{ display: "flex", flexDirection: "row", gap: "5px", fontSize: "13px" }}>
                <div>
                  {migratedBenfData?.gender_name === 'Female' ? <WomanIcon /> : <ManIcon />} {migratedBenfData?.gender_name}
                </div>
              </div>
            </div>
            <div>
              <div>
                <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                  <Button
                    onClick={() => handleUploadClick('local')}
                    disabled={false}
                    id="add-profile-picture"
                    buttonName={imageUrl !== '' ? 'Change Profile Picture' : "+ Add Profile Picture"}
                    colorType={'primary'}
                    iconPosition={'left'}
                  />
                  <span className='tooltip-profile-pic'><CustomTooltip text={'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'} /></span>
                </div>

                {imageError.length > 0 && <InfoBar
                  variant="danger"
                  message={imageError}
                  className="input_field_class profile-pic-error"
                />}
              </div>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={handleFileChange}
                className="profile-picture-hidden-input"
                ref={inputRef}
              />
            </div>
            {imageUrl !== '' && <Button
              onClick={() => {
                setImageUrl('')
                dispatch(updateForm("file", null));
              }}
              disabled={false}
              id="delete-profile-picture"
              buttonName={'Delete'}
              colorType={'save'}
            />}

          </div>
        </div>
        <div className="content">
          <LeftNavBar
            navItems={['Beneficiary Details']}
            currentTab={'Beneficiary Details'}
            handleNavClick={() => { }}
          />
          <div className="tab-content">
            <div className="temp_beneficiary_create">
              <div className="create_temp_beneficiary">
                 {<div className="cancel-edit">
                  {<Button
                    onClick={() => {
                      setCloseModal(true)
                    }}
                    disabled={false}
                    id="cancel"
                    buttonName={'Cancel'}
                    colorType={'save'}
                    icon={''}
                    iconPosition={'right'}

                  />}
                  {closeModal && <CloseModal closeModal={closeCreateModal} showModal={closeModal} messageToDisplay="Changes will not be saved.Are you sure you want to cancel?"/>}
                  <Button
                    onClick={handleSubmit}
                    disabled={false}
                    id={''}
                    buttonName={'Submit'}
                    colorType={'primary'}
                    iconPosition={'right'}
                  />
                </div>}
                <BadgesComponent
                  className="over-badge"
                  badgeName="Personal Details"
                  variant="primary-1"
                  badgeType="case5"
                />
                <div className="overview-details-update">
                  <div className="migrated_temp_beneficiary_page">
                    <BeneficiaryRedgeOptionModal showModal={showRedgOptionBeneficiary} handleClose={closeBeneficiarRedgOptionModal} showTempRegistration={false} />
                    <AuthenticationOptionModal showModal={showAuthBeneficiary} handleClose={closeBeneficiarAuthModal} />
                    <VerificationModal showModal={showVerificationBeneficiary} handleClose={closeVerificationBeneficiary} setLinkedBenefDetails={setLinkedBenefDetails}/>
                    <OTPVerification showModal={showOTP} handleClose={closeOTPModal} setLinkedBenefDetails={setLinkedBenefDetails}/>
                    <Demographic showModal={showDemographicModal} handleClose={closeDemographicModal} setLinkedBenefDetails={setLinkedBenefDetails}/>
                    <BenefeciaryUnderMobNo showModal={showBenefeciaryUnderMobNoModal} handleClose={closeBenefeciaryUnderMobNoModal} />                  
                    <BeneficiaryExistsModal showModal={showExistsModal} handleClose={closeBeneficiaryExistModal} linkedBenefDetails={linkedBenefDetails} setLinkedBenefDetails={setLinkedBenefDetails}/>
                   <form className="temp_create_container_page">
                      <CommonFormFields
                        formData={temproryBenificiaryformdata}
                        formState={temproryBenificiaryFormState}
                        handleFormChange={handleFormChange}
                      />
                      <div className='migrated_temp_beneficiary_page_abha_verify_button'>
                      <Button 
                          onClick={handleVerifyButton} 
                          disabled={temproryBenificiaryFormState?.abha_number.value?true:false}
                          buttonName={'Verify'} 
                          colorType={''} 
                          id={''}   
                        />  
                         </div> 
                    </form>       
                  </div>
                </div>
                <hr></hr>
                <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Service Provider"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_service_provider">
                                <form className="edit_container_page">
                                    <CommonFormFields
                                        formData={beneficiaryServiceProviderData}
                                        formState={beneficiaryServiceProviderForm}
                                        handleFormChange={handleServiceDetailsFormChange}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                    <span style={{ borderLeft: "1px solid #8080805e", height: "100px" }}></span>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Facility Details"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_facility_details">
                                <form className="edit_container_page">
                                    <CommonFormFields
                                        formData={beneficiaryFacilityDetailsData}
                                        formState={beneficiaryFacilityDetailsForm}
                                        handleFormChange={handleFacilityDetailsFormChange}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </main>
    </div>}
    </>
  );
};

export default MigratedTemporaryBenificiary;